module.exports = __webpack_public_path__ + "img/head_portrait2.f29718c3.png";